module.exports = __webpack_public_path__ + "assets/img/WechatIMG57.edb33077.png";